import { InspectionsManagerPage } from "./InspectionsManagerPage";

const InspectionsManager = () => {
	return <InspectionsManagerPage />;
};

export default InspectionsManager;
